import {useNavigate, useParams} from 'react-router-dom';
import PlantingProjectEditor from '../containers/PlantingProjectEditor/PlantingProjectEditor';
import {PlantingProjectType} from '../entities';

function ProposalNew() {
    const {projectType} = useParams();
    const projectTypeEnum = parseInt(projectType) as PlantingProjectType;
    const navigate = useNavigate();

    function handleProjectAdded(id: number) {
        navigate(`/proposals/${id}`);
    }

    return (
        <PlantingProjectEditor
            proposalMode={true}
            newProject={true}
            newProjectType={projectTypeEnum}
            projectAdded={handleProjectAdded}
        />
    );
}

export default ProposalNew;
